export default __webpack_public_path__ + "static/media/mobile_88.3aa39e07.jpg";